import { useState } from "react";
import { Car, ExternalLink } from "lucide-react";

const CarRental = () => {
  const providers = [
    {
      name: "Rentalcars.com",
      url: "https://www.rentalcars.com",
      description: "Compare all major car rental companies",
      iconBg: "bg-gradient-to-br from-indigo-500 to-blue-600",
    },
    {
      name: "Kayak Cars",
      url: "https://www.kayak.com/cars",
      description: "Search hundreds of car rental sites",
      iconBg: "bg-gradient-to-br from-orange-500 to-amber-600",
    },
    {
      name: "Hertz",
      url: "https://www.hertz.com",
      description: "Worldwide car rental leader",
      iconBg: "bg-gradient-to-br from-yellow-500 to-amber-600",
    },
    {
      name: "Enterprise",
      url: "https://www.enterprise.com",
      description: "We'll pick you up",
      iconBg: "bg-gradient-to-br from-emerald-500 to-green-600",
    },
    {
      name: "Avis",
      url: "https://www.avis.com",
      description: "We try harder",
      iconBg: "bg-gradient-to-br from-red-500 to-rose-600",
    },
    {
      name: "Europcar",
      url: "https://www.europcar.com",
      description: "Moving your way",
      iconBg: "bg-gradient-to-br from-sky-500 to-cyan-600",
    },
    {
      name: "Sixt",
      url: "https://www.sixt.com",
      description: "Premium car rental worldwide",
      iconBg: "bg-gradient-to-br from-orange-500 to-red-600",
    },
    {
      name: "Budget",
      url: "https://www.budget.com",
      description: "Drive happy, drive budget",
      iconBg: "bg-gradient-to-br from-blue-500 to-indigo-600",
    },
  ];

  return (
    <div className="page-container" data-testid="car-rental-page">
      <div className="pb-28">
        {/* Hero Banner */}
        <div className="relative h-36 sm:h-44 overflow-hidden mb-6">
          <img src="https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=1200&q=80" alt="" className="w-full h-full object-cover" loading="lazy" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#080d19]/80 via-[#080d19]/20 to-transparent" />
          <div className="absolute bottom-0 left-0 right-0 p-4 pb-5">
            <h1 className="text-2xl font-bold font-heading text-white drop-shadow-lg">Car Rental</h1>
            <p className="text-sm text-slate-300/80 mt-0.5 drop-shadow">Rent a car for your trip</p>
          </div>
        </div>
        <div className="px-4">

        {/* Provider Cards */}
        <div>
          <h2 className="text-lg font-semibold text-white mb-4">Car Rental Sites</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {providers.map((provider, idx) => (
              <a
                key={idx}
                href={provider.url}
                target="_blank"
                rel="noopener noreferrer"
                className="glass-card p-4 hover:scale-[1.02] transition-all group border-2 border-transparent hover:border-white/20"
                data-testid={`provider-${provider.name.toLowerCase().replace(/\./g, "")}`}
              >
                <div className="flex items-center gap-4">
                  <div
                    className={`w-14 h-14 rounded-xl ${provider.iconBg} flex items-center justify-center shadow-lg`}
                  >
                    <Car className="w-7 h-7 text-white" />
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center gap-2">
                      <h3 className="font-bold text-white text-lg">{provider.name}</h3>
                      <ExternalLink className="w-4 h-4 text-white/60 group-hover:text-white transition-colors" />
                    </div>
                    <p className="text-sm text-white/70">{provider.description}</p>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>

        {/* Tips */}
        <div className="mt-6 glass-card p-4">
          <h3 className="font-semibold text-white mb-3">Car Rental Tips</h3>
          <ul className="space-y-2 text-sm text-zinc-400">
            <li className="flex items-start gap-2">
              <span className="text-indigo-400">•</span>
              Book early for better rates, especially during peak seasons
            </li>
            <li className="flex items-start gap-2">
              <span className="text-indigo-400">•</span>
              Check if your credit card includes rental car insurance
            </li>
            <li className="flex items-start gap-2">
              <span className="text-indigo-400">•</span>
              Consider fuel policies - full-to-full is often most economical
            </li>
            <li className="flex items-start gap-2">
              <span className="text-indigo-400">•</span>
              Photograph the car before and after rental
            </li>
          </ul>
        </div>
        </div>
      </div>
    </div>
  );
};

export default CarRental;
